module.exports = __webpack_public_path__ + "img/infoguidance_mov_08.8c6b60e7.jpg";